import React, { Component } from 'react';
import CartItem from '../CartItem/CartItem';
import './CartList.scss';

class CartList extends Component {
  render() {
    const { value } = this.props;
    const { cart } = this.props.value;
    return (
      <div className='cart-items__list'>
        {cart.map(item => (
          <CartItem key={item.id} item={item} value={value} />
        ))}
      </div>
    );
  }
}

export default CartList;
